module.exports = __webpack_public_path__ + "img/gongshang1.69dde0d2.png";